

import React from "react";

import { useNavigate, useParams } from "react-router-dom";

import {

  Update,

  getFoodTypes,

  GetById

} from "adminApi/FoodApi/Food.js";

import { validateForm } from "utils/validation";

import { fooditemRules } from "validation/ValidationRules";

import Spinner from "Common/Globle/Spinner";

import EditFoodForm from "./Componates/EditFoodForm";

import fields from "../json/FoodListFields.json";

import useFormChange from "Hooks/useFormChange";

import useFormSubmit from "Hooks/useFormSubmit";

import useFetchAllData from "Hooks/useFetchAllData";

import useFetchFormDataById from "Hooks/useFetchFormDataById";



const EditFood = () => {



  const navigate = useNavigate();

  const { formdata } = fields;

  const { id } = useParams();



  // Initialize form values from JSON fields

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});



  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(

    initialValues,

    fooditemRules

  );



  // Fetch existing data by ID

  const { loading: loadingFetch } = useFetchFormDataById(

    id,

    formdata,

    GetById,

    setValues

  );



  const { data: FoodTypesOptions = [] } = useFetchAllData(getFoodTypes);



  // Form submit

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(

    async (formValues) => {

      const formData = new FormData();

      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));

      return await Update({ id, data: formData });

    },

    (vals) => {

      const err = validateForm(vals, fooditemRules)

      setErrors(err);

      return err;

    },

    () => navigate(-1),

    "Food Created Successfully"

  );



  return (

    <>

      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}

      <EditFoodForm

        fields={formdata}

        values={values}

        errors={errors}

        handleChange={handleChange}

        handleSubmit={(e) => handleSubmit(e, values)}

        loading={loadingSubmit}

        FoodTypesOptions={FoodTypesOptions}

        title="Update Food Item"

        handleFileChange={handleFileChange}

        imagePreview={values.imagePreview || values.image}

      />

    </>

  );



};



export default EditFood;

